export const SSO_LOCK_KEY = 'r3ui-sso-start-lock';
export const SSO_AUTH_URL_KEY = 'r3ui-sso-auth-url';
export const SSO_BOOTSTRAP_ABORT_KEY = 'r3ui-sso-bootstrap-abort';

type SessionLike = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;

function defaultSession(): SessionLike | null {
  try {
    if (typeof sessionStorage === 'undefined') {
      return null;
    }
    return sessionStorage;
  } catch {
    return null;
  }
}

export function httpStatusFromUnknown(error: unknown): number | null {
  if (!error || typeof error !== 'object') {
    return null;
  }
  const raw = error as { status?: unknown; statusCode?: unknown };
  const status = raw.statusCode ?? raw.status;
  return typeof status === 'number' ? status : null;
}

export function shouldAbortSsoAfterUserLoadError(error: unknown): boolean {
  const status = httpStatusFromUnknown(error);
  return status === null || status >= 500;
}

export function abortSsoAfterUserLoadFailure(
  storage: SessionLike | null = defaultSession()
): void {
  if (!storage) {
    return;
  }
  storage.setItem(SSO_BOOTSTRAP_ABORT_KEY, '1');
  storage.removeItem(SSO_LOCK_KEY);
  storage.removeItem(SSO_AUTH_URL_KEY);
}

export function isSsoBootstrapAborted(
  storage: SessionLike | null = defaultSession()
): boolean {
  if (!storage) {
    return false;
  }
  return storage.getItem(SSO_BOOTSTRAP_ABORT_KEY) === '1';
}
